import React, { useState, useRef, useEffect } from 'react';
import { FaUserCircle, FaSignOutAlt, FaCog } from 'react-icons/fa';
import { logout } from '../../../auth';
import './HeaderAvatar.scss';
import RoleGuard from '../RoleGuard';
import { UserRoles } from '../../../constants/UserRoles';
import { Link } from 'react-router-dom';
import { useAuth } from '../../../context/AuthContext';

interface HeaderAvatarProps {
  showLabel?: boolean;
}

const HeaderAvatar: React.FC<HeaderAvatarProps> = ({ showLabel = false }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);
  const { user, logout } = useAuth();

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setMenuOpen(false);
      }
    }
    if (menuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [menuOpen]);

  return (
    <div className="header-avatar" ref={menuRef}>
      <button
        className="header-avatar__button"
        onClick={() => setMenuOpen(m => !m)}
        aria-label="Open user menu"
        aria-haspopup="true"
        aria-expanded={menuOpen}
      >
        <FaUserCircle size={28} />
        {showLabel && user?.fullName && (
          <span className="header-avatar__name">{user.fullName}</span>
        )}
      </button>
      {menuOpen && (
        <div className="header-avatar__menu">
          <RoleGuard roles={UserRoles.Admin + "," + UserRoles.Manager}>
            <Link to="/settings" 
             className="header-avatar__settings"
             onClick={e => {
                e.stopPropagation();
                setMenuOpen(false);
            }}>
                <FaCog style={{marginRight: 12}}/> Settings
            </Link>
          </RoleGuard>
          <button className="header-avatar__logout" onClick={logout}>
            <FaSignOutAlt style={{marginRight: 6}}/>Logout
          </button>
        </div>
      )}
    </div>
  );
};

export default HeaderAvatar;
